<div class="expansion-molecule-root">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <app-label isBig>{{title}}</app-label>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</div>
